import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
    id: "career-modal",
    class: "modal type2 js-modal"
};
const _hoisted_2 = { class: "modal-content" };
const _hoisted_3 = { class: "pop" };
const _hoisted_4 = {
    key: 0,
    class: "err"
};
const _hoisted_5 = { for: "job1_2_a1" };
const _hoisted_6 = {
    key: 0,
    class: "err"
};
const _hoisted_7 = {
    key: 0,
    class: "err"
};
const _hoisted_8 = {
    key: 0,
    class: "err"
};
const _hoisted_9 = {
    key: 0,
    class: "err"
};
const _hoisted_10 = { class: "bt_box clear" };
import { ref, reactive, watch } from 'vue';
import Alert from '@util/BrowserAlert';
import ImageFrame from '@component/ImageFrame.vue';
import Formatter from '@util/Formatter';
import { nextTick } from 'process';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CareerModal',
    props: {
        form: {}
    },
    emits: ['input'],
    setup(__props, { emit: __emit }) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        const props = __props;
        const emit = __emit;
        let tempForm = ref({
            id: (_b = (_a = props.form) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null,
            started_at: (_d = (_c = props.form) === null || _c === void 0 ? void 0 : _c.started_at) !== null && _d !== void 0 ? _d : '',
            is_ended: (_f = (_e = props.form) === null || _e === void 0 ? void 0 : _e.is_ended) !== null && _f !== void 0 ? _f : true,
            ended_at: (_h = (_g = props.form) === null || _g === void 0 ? void 0 : _g.ended_at) !== null && _h !== void 0 ? _h : null,
            organization: (_k = (_j = props.form) === null || _j === void 0 ? void 0 : _j.organization) !== null && _k !== void 0 ? _k : '',
            department: (_m = (_l = props.form) === null || _l === void 0 ? void 0 : _l.department) !== null && _m !== void 0 ? _m : '',
            position: (_p = (_o = props.form) === null || _o === void 0 ? void 0 : _o.position) !== null && _p !== void 0 ? _p : '',
            experience_content: (_r = (_q = props.form) === null || _q === void 0 ? void 0 : _q.experience_content) !== null && _r !== void 0 ? _r : '',
        });
        const messages = {
            started_at: '開始時期を入力してください',
            organization: '組織を入力してください',
            department: '部署を入力してください',
            position: '役職を入力してください',
            experience_content: '経験内容を入力してください',
        };
        const errors = reactive({
            started_at: '',
            organization: '',
            department: '',
            position: '',
            experience_content: '',
        });
        const close = ref();
        const focus_target = ref();
        let modal_inital_status = true;
        watch(() => tempForm.value.ended_at, (value) => {
            tempForm.value.is_ended = (value === null);
        });
        watch(() => props.form, (value) => {
            // focusing the top of content.
            if (!value.id && modal_inital_status) {
                modal_inital_status = false;
                const focusTarget = focus_target.value;
                nextTick(() => {
                    focusTarget.focus();
                });
            }
            ;
            if (value) {
                tempForm.value = value;
            }
        }, { deep: true });
        // 文字数チェック
        watch(() => tempForm.value.organization, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.value.organization = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => tempForm.value.department, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.value.department = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => tempForm.value.position, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.value.position = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => tempForm.value.experience_content, (value) => {
            if (Alert.charLimitTextArea(value)) {
                tempForm.value.experience_content = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        // バリデーションチェック
        const validate = (obj) => {
            let back = false;
            Object.keys(errors).forEach((key) => {
                errors[key] = '';
                if (obj[key].trim() === '') {
                    back = true;
                    errors[key] = messages[key];
                }
            });
            return back;
        };
        const onOK = () => {
            tempForm.value.started_at = Formatter.formatDate(tempForm.value.started_at, 'YYYY/MM');
            let endedAt = Formatter.formatDate(tempForm.value.ended_at, 'YYYY/MM');
            tempForm.value.ended_at = endedAt;
            tempForm.value.is_ended = endedAt.trim() == '';
            if (!validate(tempForm.value)) {
                close.value.click();
                emit('input', tempForm.value);
            }
        };
        const onClose = () => {
            modal_inital_status = true;
            Object.keys(errors).forEach((key) => {
                errors[key] = '';
            });
        };
        const onInputStartedAt = (event) => {
            tempForm.value.started_at = event.target.value;
        };
        const onInputEndedAt = (event) => {
            tempForm.value.ended_at = event.target.value;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "modal-bg bt_modal_close",
                    onClick: onClose
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: "close_bt bt_modal_close",
                        onClick: onClose
                    }, [
                        _createVNode(ImageFrame, { src: "images/common/i_bt_close.svg" })
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _cache[17] || (_cache[17] = _createElementVNode("h2", null, "職歴登録", -1)),
                        _createElementVNode("dl", null, [
                            _cache[11] || (_cache[11] = _createElementVNode("dt", null, "開始時期", -1)),
                            _createElementVNode("dd", null, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(tempForm).started_at) = $event)),
                                    type: "text",
                                    name: "ym_1_1",
                                    class: "c-ym",
                                    placeholder: "日付選択▼",
                                    onInput: onInputStartedAt,
                                    autocomplete: "off"
                                }, null, 544), [
                                    [_vModelText, _unref(tempForm).started_at]
                                ]),
                                (errors === null || errors === void 0 ? void 0 : errors.started_at)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(errors.started_at), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _cache[12] || (_cache[12] = _createElementVNode("dt", null, "終了時期", -1)),
                            _createElementVNode("dd", null, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(tempForm).is_ended) = $event)),
                                    value: false,
                                    class: "visually-hidden",
                                    type: "radio",
                                    name: "job1_2",
                                    id: "job1_2_a1",
                                    autocomplete: "off",
                                    ref_key: "focus_target",
                                    ref: focus_target
                                }, null, 512), [
                                    [_vModelRadio, _unref(tempForm).is_ended]
                                ]),
                                _createElementVNode("label", _hoisted_5, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(tempForm).ended_at) = $event)),
                                        type: "text",
                                        name: "ym_1_2",
                                        class: "c-ym",
                                        placeholder: "日付選択▼",
                                        onInput: onInputEndedAt,
                                        autocomplete: "off"
                                    }, null, 544), [
                                        [_vModelText, _unref(tempForm).ended_at]
                                    ])
                                ]),
                                _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(tempForm).is_ended) = $event)),
                                    value: true,
                                    class: "visually-hidden",
                                    type: "radio",
                                    name: "job1_2",
                                    id: "job1_2_a2",
                                    onChange: _cache[4] || (_cache[4] = ($event) => (_unref(tempForm).ended_at = null))
                                }, null, 544), [
                                    [_vModelRadio, _unref(tempForm).is_ended]
                                ]),
                                _cache[10] || (_cache[10] = _createElementVNode("label", { for: "job1_2_a2" }, "在籍中", -1))
                            ]),
                            _cache[13] || (_cache[13] = _createElementVNode("dt", null, "組織", -1)),
                            _createElementVNode("dd", null, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(tempForm).organization) = $event)),
                                    type: "text",
                                    name: "job1_3",
                                    class: "wmax inquiry-form",
                                    placeholder: "組織名"
                                }, null, 512), [
                                    [_vModelText, _unref(tempForm).organization]
                                ]),
                                (errors === null || errors === void 0 ? void 0 : errors.organization)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(errors.organization), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _cache[14] || (_cache[14] = _createElementVNode("dt", null, "部署", -1)),
                            _createElementVNode("dd", null, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(tempForm).department) = $event)),
                                    type: "text",
                                    name: "job1_4",
                                    class: "wmax inquiry-form",
                                    placeholder: "部署"
                                }, null, 512), [
                                    [_vModelText, _unref(tempForm).department]
                                ]),
                                (errors === null || errors === void 0 ? void 0 : errors.department)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errors.department), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _cache[15] || (_cache[15] = _createElementVNode("dt", null, "役職", -1)),
                            _createElementVNode("dd", null, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(tempForm).position) = $event)),
                                    type: "text",
                                    name: "job1_5",
                                    class: "wmax inquiry-form",
                                    placeholder: "役職"
                                }, null, 512), [
                                    [_vModelText, _unref(tempForm).position]
                                ]),
                                (errors === null || errors === void 0 ? void 0 : errors.position)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(errors.position), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _cache[16] || (_cache[16] = _createElementVNode("dt", null, [
                                _createTextVNode(" 経験内容"),
                                _createElementVNode("br", { class: "pc" }),
                                _createElementVNode("p", { class: "sub" }, "要約、規模、担当業務、担当実績、etc.")
                            ], -1)),
                            _createElementVNode("dd", null, [
                                _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(tempForm).experience_content) = $event)),
                                    placeholder: "経験内容",
                                    id: "textarea_3",
                                    oninput: "resizeTextarea(3,7)"
                                }, null, 512), [
                                    [_vModelText, _unref(tempForm).experience_content]
                                ]),
                                (errors === null || errors === void 0 ? void 0 : errors.experience_content)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(errors.experience_content), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                _createElementVNode("li", null, [
                                    _createElementVNode("p", {
                                        class: "bt_modal_close bt_clear",
                                        onClick: onClose
                                    }, "キャンセル")
                                ]),
                                _createElementVNode("li", null, [
                                    _createElementVNode("p", {
                                        class: "bt_ok",
                                        onClick: onOK
                                    }, "OK")
                                ])
                            ]),
                            _createElementVNode("p", {
                                class: "bt_modal_close",
                                ref_key: "close",
                                ref: close,
                                style: { "display": "none" },
                                onClick: onClose
                            }, null, 512)
                        ])
                    ])
                ])
            ]));
        };
    }
});
